export default "__VITE_ASSET__B0_Q6Nls__"